import { Injectable } from "@angular/core";
import { MapperInterface } from "./mapper-inteface";
import { DecretoDTO } from "../dto/decretoDTO";
import { DecretoVO } from "../vo/decretoVO";
import { MapperMetadatiRepertorio } from "./mapper-metadati-repertorio";

@Injectable({
  providedIn: "root",
})
export class MapperDecreto implements MapperInterface<DecretoDTO, DecretoVO> {
  constructor(private mapperMetadatiRepertorio: MapperMetadatiRepertorio) { }

  convertVoToDto(vo: DecretoVO): DecretoDTO {
    if (vo != null) {
      const dto = new DecretoDTO();
      dto.id = vo.id;

      dto.oggetto = vo.oggetto;
      dto.metadatiRepertorio = this.mapperMetadatiRepertorio.convertVoToDto(
        vo.metadatiRepertorio
      );
      dto.dataConclusione = vo.dataConclusione;
      return dto;
    } else {
      return null;
    }
  }

  convertDtoToVo(dto: DecretoDTO): DecretoVO {
    if (dto != null) {
      const vo = new DecretoVO();

      vo.id = dto.id;
      vo.oggetto = dto.oggetto;
      vo.metadatiRepertorio = this.mapperMetadatiRepertorio.convertDtoToVo(
        dto.metadatiRepertorio
      );
      vo.dataConclusione = dto.dataConclusione;

      return vo;
    } else {
      return null;
    }
  }

  convertListVoToDto(voList: DecretoVO[]): DecretoDTO[] {
    if (voList != null) {
      return voList.map((vo) => this.convertVoToDto(vo));
    } else {
      return null;
    }
  }

  convertListDtoToVo(dtoList: DecretoDTO[]): DecretoVO[] {
    if (dtoList != null) {
      return dtoList.map((dto) => this.convertDtoToVo(dto));
    } else {
      return null;
    }
  }
}
